import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';

const SITE_KEY = app.settings.frb_prod ? '6Lc771clAAAAAG3RojZGiIl3q-1XW_aYoJ_tHc9x' : '6Led7VclAAAAABzvkrBHo9YrGFQ0hY-9kIJ-Dw1A';
const SRC = `https://www.google.com/recaptcha/api.js`;
const RE_CAPTCHA_ID = 'recaptcha';

const ReCaptcha = ({ onComplete, onError, isRedLabel, label = 'For security purposes, please complete the reCAPTCHA challenge below*', ...props }, ref) => {
	const widgetId = useRef();

	useEffect(() => {
		const onLoadCallback = () => {
			window.grecaptcha.ready(() => {
				widgetId.current = window.grecaptcha.render(RE_CAPTCHA_ID, {
					sitekey: SITE_KEY,
					size: 'normal',
					callback: (token) => {
						onComplete?.(token);
					},
					'expired-callback': () => {
						onError?.();
					},
					'error-callback': () => {
						onError?.();
					},
					...props
				});
			});
		};

		const script = document.createElement('script');
		script.src = SRC;
		script.async = true;
		script.addEventListener('load', onLoadCallback);
		document.head.appendChild(script);

		return () => {
			document.head.removeChild(script);
		};
	}, []);

	useImperativeHandle(ref, () => ({
		resetCaptcha: () => window.grecaptcha.reset(widgetId.current),
	}));

	return (
		<>
			{label && (
				<label className="inline-block mb-2" style={{ color: isRedLabel ? '#9F3A38' : undefined }}>
					{label}
				</label>
			)}
			<div id={RE_CAPTCHA_ID} />
		</>
	);
};

export default forwardRef(ReCaptcha)
